module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tokens box"
  }, _vm._l((_vm.tokens), function(ref) {
    var token = ref[0];
    var count = ref[1];

    return (_vm.search) ? _c('div', {
      staticClass: "token",
      on: {
        "click": function($event) {
          _vm.applyToken(token)
        }
      }
    }, [_vm._v("\n    " + _vm._s(token) + "\n  ")]) : _vm._e()
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11777196","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tokens.vue
// module id = 541
// module chunks = 1